import { __rest } from 'tslib';
import { jsxs, jsx } from 'react/jsx-runtime';
import classNames from 'classnames';

var EyeShowIcon = function EyeShowIcon(_a) {
  var className = _a.className,
    otherProps = __rest(_a, ["className"]);
  return jsxs("svg", Object.assign({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-label": "EyeShowIcon",
    role: "img",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    fill: "none",
    className: classNames('cogs-icon', className)
  }, otherProps, {
    children: [jsx("path", {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M2.76 8q.046-.128.133-.323c.15-.326.396-.763.778-1.2C4.418 5.624 5.724 4.725 8 4.725s3.582.899 4.33 1.752A5 5 0 0 1 13.24 8a5.006 5.006 0 0 1-.91 1.523c-.748.854-2.054 1.752-4.33 1.752s-3.582-.899-4.33-1.752A5 5 0 0 1 2.76 8M14 8l.703.177v.003l-.002.005-.004.016a3 3 0 0 1-.063.204c-.044.13-.112.31-.21.522-.194.424-.51.987-1.003 1.55-1.003 1.146-2.697 2.248-5.421 2.248s-4.418-1.101-5.42-2.248a6.5 6.5 0 0 1-1.005-1.55 5.5 5.5 0 0 1-.272-.726L1.3 8.185l-.001-.005v-.002c-.001 0-.001-.002.702-.178a57 57 0 0 1-.703-.177V7.82l.002-.005.004-.016a3 3 0 0 1 .063-.204c.044-.13.112-.31.21-.522a6.5 6.5 0 0 1 1.003-1.55C3.582 4.377 5.276 3.275 8 3.275c2.723 0 4.418 1.102 5.42 2.248a6.5 6.5 0 0 1 1.005 1.55 5.5 5.5 0 0 1 .272.726l.004.016.001.005v.002c.001 0 .001.002-.702.178m0 0 .703.177.044-.177-.044-.176zM2 8l-.703.176L1.253 8l.044-.177z",
      clipRule: "evenodd"
    }), jsx("path", {
      fill: "currentColor",
      d: "M10 8a2 2 0 1 1-4 0 2 2 0 0 1 4 0"
    })]
  }));
};

export { EyeShowIcon };
